import type { ReactNode } from 'react';

export enum PRODUCT_LIST_CONST {
  TEST_ID = 'product-list',
}

export type ProductListProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  itemsPerRowDesktop?: 3 | 4;
};

export type SkeletonListProps = {
  itemsPerRowDesktop?: ProductListProps['itemsPerRowDesktop'];
  quantity?: number;
};

export default ProductListProps;
